((docs) => {

  const myDoc = docs;

  const menuDropdown = (nai) => {
    const menu = myDoc.querySelector(nai);
    const offcanv = myDoc.querySelector('.nav-min');
    let mediaQ = window.matchMedia(`(max-width: 991px)`);
    //let menu = myDoc.querySelector('.nav-min-menu');
    let dropMenuItems = menu.querySelectorAll('.haveChild');
    if (mediaQ.matches) {
      let mobMnuHdr = myDoc.querySelector('.nav-min-header');
      let mobMnuCloser = myDoc.querySelector('.nav-min-close');
      Object.keys(dropMenuItems).forEach((key) => {
        let item = dropMenuItems[key].querySelector('a');
        //console.log(item);
        let subMenu = dropMenuItems[key].querySelector('.dropdown-menu');
        let chieldCloseBtn = subMenu.querySelector('.nav-min-menu-children-closer');
        item.addEventListener('click', (e) => {
          e.preventDefault();
          subMenu.classList.add('show');
          mobMnuHdr.classList.add('position-fixed');
        });
        chieldCloseBtn.addEventListener('click', (e) => {
          e.preventDefault();
          subMenu.classList.remove('show');
          setTimeout(() => {
            mobMnuHdr.classList.remove('position-fixed');
          }, 10);
        });
        mobMnuCloser.addEventListener('click', (e) => {
          subMenu.classList.remove('show');
          setTimeout(() => {
            mobMnuHdr.classList.remove('position-fixed');
          }, 10);
        });
      });


      offcanv.addEventListener('hide.bs.offcanvas', event => {
        mobMnuHdr.classList.remove('position-fixed');
      });



    } else {
      let dropMenu = menu.querySelectorAll('.dropdown');
      let overlayEle = myDoc.createElement('div');
      overlayEle.className = 'overlay';

      myDoc.addEventListener('click', (e) => {
        let dropMenuTglr = e.target.closest('.dropdown-menu');
        if (!dropMenuTglr && overlayEle) {
          overlayEle.remove();
        }
      });

      dropMenu.forEach((item) => {
        item.addEventListener('show.bs.dropdown', event => {
          setTimeout(() => {
            let dropOverBg = myDoc.querySelector('.overlay');
            !dropOverBg ? myDoc.body.appendChild(overlayEle) : '';
          }, 6);
        });
      });
    }

  };

  menuDropdown('.nav-min-menu');


  let filter = myDoc.querySelector('.filter-btn');
  if (filter) {
    let eachClick = true;
    filter.addEventListener('click', (e) => {
      let filterPanl = myDoc.querySelector('.filter');
      let galView = myDoc.querySelector('.gallery-view');
      if (eachClick) {
        eachClick = false;
        filterPanl.classList.add('show');
        galView.classList.add('col-xl-10');
      } else {
        eachClick = true;
        filterPanl.classList.remove('show');
        galView.classList.remove('col-xl-10');
      }
    });

    let filterClose = myDoc.querySelector('.filter-close');
    filterClose.addEventListener('click', (e) => {
      let filterPanl = myDoc.querySelector('.filter');
      let galView = myDoc.querySelector('.gallery-view');
      filterPanl.classList.remove('show');
      galView.classList.remove('col-xl-10');
      eachClick = true;
    });
  }

  //search
  document.addEventListener("DOMContentLoaded", function () {
    function closeSearch(searchElement) {
        setTimeout(() => {
            searchElement.classList.remove("open");
            document.removeEventListener("mouseup", handleClickOutside);
            document.removeEventListener("keyup", handleEscape);
        }, 100);
    }

    function handleClickOutside(event) {
        const searchContainer = document.querySelector(".searchbdy.open");
        if (searchContainer) {
            const form = searchContainer.querySelector("form");
            if (!form.contains(event.target)) {
                closeSearch(searchContainer);
            }
        }
    }

    function handleEscape(event) {
        if (event.key === "Escape") {
            const searchContainer = document.querySelector(".searchbdy.open");
            if (searchContainer) closeSearch(searchContainer);
        }
    }

    document.getElementById("js-search-openable").addEventListener("click", function () {
        const searchContainer = this.closest(".searchbdy");

        if (!searchContainer.classList.contains("open")) {
            searchContainer.classList.add("open");
            searchContainer.querySelector("input:first-child").focus();

            document.addEventListener("mouseup", handleClickOutside);
            document.addEventListener("keyup", handleEscape);
        }
    });
});


  //favourite
  myDoc.addEventListener('click', function (event) {
    //console.log(event.target);
    if (event.target.classList.contains('favourites-icon')) {
      event.target.classList.toggle('active');
      if (event.target.classList.contains('active')) {
        event.target.parentElement.querySelector('.favourites-message').textContent = 'Added to favourites!';
      } else {
        event.target.parentElement.querySelector('.favourites-message').textContent = 'Removed from Favourites!';
      }
      event.target.parentElement.querySelector('.favourites-message').classList.add('active');
    }
  });

  myDoc.addEventListener('click', function (event) {
    if (event.target.classList.contains('favourites-message')) {
      event.target.classList.remove('active');
    }
  });

  myDoc.addEventListener('click', function (event) {
    if (!event.target.closest('.favourites')) {
      myDoc.querySelectorAll('.favourites-message').forEach(function (message) {
        message.classList.remove('active');
      });
    }
  });


  // const formGroup = myDoc.querySelectorAll('.form-group');
  // if(formGroup) {
  //   Object.keys(formGroup).forEach(i =>{
  //     let lable = formGroup[i].querySelector('label');
  //     let input = formGroup[i].querySelector('.form-control');
  //     if(lable) {
  //       input.addEventListener('blur', (e)=>{
  //         if(e.target.value!==''){
  //           e.target.classList.add('hasVal');
  //         }else{
  //           e.target.classList.remove('hasVal');
  //         }
  //       })
  //     }
  //   })
  // }

  //input select dropdown selectted image needs to show on image tag
  let selectScContainer = myDoc.querySelectorAll('.select-escort');
  if (selectScContainer) {
    Object.keys(selectScContainer).forEach(i => {
      let image = selectScContainer[i].querySelector('.booking-img');
      let input = selectScContainer[i].querySelector('.form-control');
      if (image) {
        let prevSec = image.src;
        input.addEventListener('change', (e) => {
          let img = e.target.options[e.target.selectedIndex].getAttribute('data-value');
          if (img) {
            e.target.closest('.select-escort').querySelector('.booking-img').src = img;
          } else {
            e.target.closest('.select-escort').querySelector('.booking-img').src = prevSec;
            //console.log(prevSec);
          }
          //console.log(img);
        })
      }
    })
  };


  // Select the button and filtercontent element
  const toggleButton = myDoc.getElementById('toggleButton');
  const filtercontent = myDoc.getElementById('filtercontent');
  if (toggleButton) {
    // Add a click event listener to the button
    toggleButton.addEventListener('click', () => {
      // Check the current display state of the filtercontent
      if (filtercontent.style.display === 'none' || filtercontent.style.display === '') {
        filtercontent.style.display = 'block'; // Show the filtercontent

      } else {
        filtercontent.style.display = 'none'; // Hide the filtercontent

      }
    });
  }



  let splideRight = myDoc.querySelector('.splideRight');
        if (splideRight) {
            var reviewSplide = new Splide(splideRight, {
                arrows: false,
                type: 'loop', // Enable looping
                perMove: 1, // Move 1 slide at a time
                // height: '100vh', // Set a fixed height
                pagination: false, // Hide pagination dots
                gap: '5px', // Space between slides
                direction: 'ttb',
                perPage: 3,
                height: '100vh',
                autoplay: true,
                interval: 3000, // Time between slides
                speed: 800, // Transition speed
                mediaQuery: 'max',
                classes: {
                    pagination: 'splide__pagination position-relative bottom-0 mt-4',
                    page: 'splide__pagination--page border-0 rounded-circle mx-1',
                },
                breakpoints: {
                    1199: {
                        perPage: 5,
                        height: 'auto',
                        direction: 0,
                    },
                    767: {
                        perPage: 3,
                        height: 'auto',
                    },
                    400: {
                        perPage: 2,
                        height: 'auto',
                    },
                }
            });
            reviewSplide.mount();
        }



        let splideLeft = myDoc.querySelector('.splideLeft');
        if (splideLeft) {
            var reviewLSplide = new Splide(splideLeft, {
                arrows: false,
                type: 'loop', // Enable looping
                perMove: 1, // Move 1 slide at a time
                // height: '100vh', // Set a fixed height
                pagination: false, // Hide pagination dots
                gap: '5px', // Space between slides
                direction: 'ttb',
                perPage: 3,
                height: '100vh',
                autoplay: true,
                interval: 3000, // Time between slides
                speed: 800, // Transition speed
                mediaQuery: 'max',
                classes: {
                    pagination: 'splide__pagination position-relative bottom-0 mt-4',
                    page: 'splide__pagination--page border-0 rounded-circle mx-1',
                },
                breakpoints: {
                    800: {
                        perPage: 5,
                        height: 'auto',
                        direction: 0,
                    },
                    767: {
                        perPage: 3,
                        height: 'auto',
                    },
                    400: {
                        perPage: 2,
                        height: 'auto',
                    },
                }
            });
            reviewLSplide.mount();
        }



  //fordesktop filtermenu open on mouse hover
  const filterDropDownOnfover = () => {
    if(filtercontent){
      let filterDropdown = filtercontent.querySelectorAll('.dropdownHover')
      if (filterDropdown && window.matchMedia(`(min-width: 1366px)`).matches) {
        filterDropdown.forEach((dropdown) => {
          dropdown.addEventListener('mouseleave', () => {
            const menu = dropdown.querySelector('.dropdown-menu');
            const dropBtn = dropdown.querySelector('.dropdown-toggle');
            dropBtn ? dropBtn.classList.remove('active') : null;
            if (menu && menu.classList.contains('show')) {
              menu.classList.remove('show')
            }

          });

          dropdown.addEventListener('mouseenter', () => {
            const menu = dropdown.querySelector('.dropdown-menu');
            const dropBtn = dropdown.querySelector('.dropdown-toggle');
            dropBtn ? dropBtn.classList.add('active') : null;
            if (menu && !menu.classList.contains('show')) {
              menu.classList.add('show')
            }
          });
        });
      }else{
        filterDropdown.forEach((dropdown) => {
          const dropBtn = dropdown.querySelector('.dropdown-toggle');
          dropBtn.classList.remove('active');
        });
      }
    }
  }
  filterDropDownOnfover();
  window.addEventListener('resize', (e) => {
    menuDropdown('.nav-min-menu');
    filterDropDownOnfover();
  });




  //custom Price Select
  if(filtercontent){
    let filterDropdown = filtercontent.querySelectorAll('.dropdownHover');
    if (filterDropdown) {
      filterDropdown.forEach((dropdown) => {
        if (dropdown.querySelector('.optionSelect')) {
          dropdown.querySelector('.optionSelect').addEventListener('mouseenter', (e) => {
            e.target.closest('.dropdownHover').classList.add('doNotClose');
          })
        }
      })
    }
  }

  myDoc.addEventListener('click', (e) => {
    try {
      !e.target.closest('.doNotClose') ? myDoc.querySelector('.dropdownHover.doNotClose').classList.remove('doNotClose') : null;
    } catch (error) {

    }
  })


  //custom optionselect
  const customOptionSelect = () => {
    let selectWrap = myDoc.querySelectorAll('.optionSelect');
    //console.log(selectWrap);
    if (selectWrap) {
      Object.keys(selectWrap).forEach(i => {
        let selectBtn = selectWrap[i].querySelector('.dropdown-toggle');
        let selectMnu = selectWrap[i].querySelectorAll('.dropdown-menu li');
        console.log(selectMnu);
        selectMnu.forEach((li) => {
          li.addEventListener('click', (e) => {
            selectBtn.setAttribute('value', e.target.dataset.value);
            selectBtn.innerHTML = e.target.dataset.value;
            selectMnu.forEach((liItem) => {
              liItem.classList.remove('active');
            });
            e.target.classList.add('active');
          })
        })
      })
    }
  }
  customOptionSelect();


  const menuButton = myDoc.getElementById('menuBtn');
  const menu = menuButton.querySelector('#menu');
  const arrow = menuButton.querySelector('.arrow');
  const handlerclick = menuButton.querySelector('.handler');
  let menubdy = false;

  handlerclick.addEventListener('click', (e) => {
    if(!menubdy){
      menu.style.display = 'block';
      arrow.style.transform = 'rotate(180deg)';
      menubdy = true;
      console.log(menu);
    }else{
      menu.style.display = 'none';
      arrow.style.transform = 'rotate(0deg)';
      menubdy = false;
      console.log(menu);
    }
  });

  // handlerclick.addEventListener('click', (e) => {
  //   // setTimeout(() => {
  //   //   menu.style.display = 'none';
  //   //   arrow.style.transform = 'rotate(0deg)';
  //   // }, 500);
  //   menu.style.display = 'none';
  //   arrow.style.transform = 'rotate(0deg)';
  // });

  // menu.addEventListener('mouseenter', () => {
  //   menu.style.display = 'block';
  // });

  // menu.addEventListener('mouseleave', () => {
  //   menu.style.display = 'none';
  //   arrow.style.transform = 'rotate(0deg)';
  // });


  const addRemoveActiveOnclick = (ele) => {
    if(ele) {
        let actinArray = myDoc.querySelectorAll(ele);
        actinArray.forEach(i => {
            let dropdownselectmenu = i.querySelectorAll('.dropdown-common-select-menu li'),
            button = i.querySelector('button');
            dropdownselectmenu.forEach(menuitem => {
              //console.log(menuitem);
              menuitem.addEventListener('click', (e)=> {
                dropdownselectmenu.forEach(item => item.classList.remove('active'))
                e.target.classList.add('active');
                //button.querySelector('span').innerText=e.target.innerHTML;
                button.innerHTML = `${e.target.innerHTML} <i class="arrow arrow-bottom arrow-right-defaultTxt ms-auto"></i>`;

                let curency =  myDoc.querySelectorAll('.rates-cur');
                if(curency) {
                    curency.forEach(curitm => curitm.innerHTML = e.target.innerHTML);
                }

                let serverVal = button.getAttribute('data-servicevalue');

                if(serverVal){
                    button.setAttribute('data-servicevalue', e.target.innerHTML);
                    if(e.target.innerHTML === 'Extra'){
                        myDoc.querySelector(`#${button.dataset.rel}`).disabled = false;
                        myDoc.querySelector(`#${button.dataset.rel}`).focus();
                    }else{
                        myDoc.querySelector(`#${button.dataset.rel}`).value = '';
                        myDoc.querySelector(`#${button.dataset.rel}`).disabled = true;
                    }
                }

              })
            })

        })
    }
}
addRemoveActiveOnclick('.select2')


  //custom upload
  const inputFilewrap = myDoc.querySelectorAll('.inputFile');
  if (inputFilewrap) {
    Object.keys(inputFilewrap).forEach(function (key) {
      inputFilewrap[key].querySelector('[type="file"]').addEventListener('change', function () {
        if (inputFilewrap[key].querySelector('[type="file"]').files.length > 0) {
          inputFilewrap[key].querySelector('.form-control').innerText = inputFilewrap[key].querySelector('[type="file"]').files[0].name;
        }
      });
    });
  }


  const switchTheme = () => {
    const themeToggle = myDoc.getElementById("theme-toggle");

    const savedTheme = localStorage.getItem("theme") || "light";
    myDoc.body.setAttribute("data-theme", savedTheme);
    myDoc.body.classList.add(`theme-${savedTheme}`);
    if(localStorage.theme === 'dark'){
      myDoc.body.classList.remove(`theme-light`);
      myDoc.body.classList.add(`theme-dark`);
    }else{
      myDoc.body.classList.remove(`theme-dark`);
      myDoc.body.classList.add(`theme-light`);
    }

    themeToggle.checked = savedTheme === "dark";

    themeToggle.addEventListener("change", () => {
      const newTheme = themeToggle.checked ? "dark" : "light";
      myDoc.body.setAttribute("data-theme", newTheme);
      if(localStorage.theme !== 'dark'){
        myDoc.body.classList.remove(`theme-light`);
        myDoc.body.classList.add(`theme-dark`);
      }else{
        myDoc.body.classList.remove(`theme-dark`);
        myDoc.body.classList.add(`theme-light`);
      }
      localStorage.setItem("theme", newTheme);
      //console.log(localStorage.theme);
    });
  }
  switchTheme();


  myDoc.addEventListener("DOMContentLoaded", function () {
    //show phone number
    const showPhoneNumber = (btn) => {
        let phoneBtn = myDoc.querySelectorAll(btn);
        if (phoneBtn) {
            phoneBtn.forEach((btn) => {
                let phoneNum = btn.dataset.number;
                btn.dataset.number = '';
                let a = document.createElement('a');
                a.className = 'text-default';
                a.innerHTML = phoneNum;
                a.href = `tel:${phoneNum.replace(/\s/g, '')}`;
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    btn.previousElementSibling?.remove();
                    btn.insertAdjacentElement('afterend', a);
                    btn.remove();
                });
            });
        }
    }
    showPhoneNumber('.show-phone');

    //init tootltip globally
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    if(! tooltipTriggerList) return;
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

    //single image Upload function
    const singleImageUpload = (inputFilewrap) => {
        if (inputFilewrap) {
            inputFilewrap.forEach((item) => {
                let inputFile = item.querySelector('input[type="file"]');
                let imgWraper = item.querySelector('.uploaded-img');
                inputFile.addEventListener('change', (e) => {
                    let file = e.target.files[0];
                    let reader = new FileReader();
                    reader.onload = function (e) {
                        imgWraper.innerHTML = `<img src="${e.target.result}" alt="uploaded image" />`;
                    }
                    reader.readAsDataURL(file);
                });
            });
        }
    }
    singleImageUpload(myDoc.querySelectorAll('.single-image-upload'));

    //show hide login form
    const shoHideLoginForm = (btn) => {
        let loginBtn = myDoc.querySelector(btn);
        let signForm = myDoc.querySelector('#signform');
        if (loginBtn) {
            loginBtn.addEventListener('click', (e) => {
                signForm.classList.toggle('active');
            });
            myDoc.addEventListener('click', (e) => {
                if (!e.target.closest('#signform') && !e.target.closest(btn)) {
                    signForm.classList.contains('active')?signForm.classList.remove('active'):null;
                }
            });
        }
    }
    shoHideLoginForm('#sign-form-handler-l');


    const imageUpload = (imgInput, uploadimg) => {
        let cropper;
        let currentImg;
        let flipX = 1,
            flipY = 1;
        const imageInput = document.querySelector(imgInput);
        const imagePreview = document.querySelector('#imagePreview');
        const cropperModal = document.getElementById('cropperModal')?new bootstrap.Modal(document.getElementById('cropperModal')):null;
        const uploadPhotos = document.querySelector(uploadimg);
        // Handle Image Input Change
        if(! imageInput) return;
        imageInput.addEventListener('change', function(event) {
            const files = event.target.files;
            if(! files) return;

            Object.keys(files).forEach((item) => {
                //console.log(files[item].name)
                let file = files[item].name;
                let reader = new FileReader();
                //imgprev.append(img, settingsBrn);
                //console.log(reader);
                if(files[item].name) {
                    reader.onload = (e) => {
                        //console.log(e.target);
                        let div = document.createElement('div');
                            div.className = 'imgprev';
                        let settingsBrn = document.createElement('span');
                            settingsBrn.className = 'fa-light fa-gear settings'
                        let img = document.createElement('img');
                            img.src=e.target.result
                            img.className = 'img-fluid';
                            div.appendChild(img);
                            div.appendChild(settingsBrn);
                       // let pictureSet = div.append(img, settingsBrn);
                        //console.log(pictureSet);
                        uploadPhotos.appendChild(div);
                    }
                    reader.readAsDataURL(files[item]);
                }
            })
        });

        document.addEventListener('click', (e) => {
            if(e.target.matches('.settings')){
                currentImg = e.target.previousElementSibling
                //console.log(imagePreview);
                imagePreview.src = currentImg.src;
                cropperModal?.show();
            }
        });

        document.getElementById('cropperModal').addEventListener('shown.bs.modal', function() {
            if (cropper) {
                cropper.destroy();
            }
            cropper = new Cropper(imagePreview, {
                aspectRatio: 1, // Change as needed (e.g., 16/9)
                viewMode: 2,
                autoCropArea: 0.8,
            });
            // Reset flip values
            flipX = 1;
            flipY = 1;
        });

        document.addEventListener('click', (evnt) => {
            let curTarg = evnt.target;
            switch (curTarg.id) {
                case 'rotateLeft':
                    if (cropper) cropper.rotate(-45);
                    break;
                case 'rotateRight':
                    if (cropper) cropper.rotate(45);
                    break;
                case 'cropImage':
                    const canvas = cropper.getCroppedCanvas();
                    if (canvas) {
                        currentImg.src = canvas.toDataURL('image/png');
                        cropperModal.hide();
                    }
                break;
            }
        })


        document.getElementById('cropperModal').addEventListener('hidden.bs.modal', function() {
            cropper.destroy();
            cropper = null;
        });
    }
    imageUpload('#imageInput', '.uploadPhotos');
    imageUpload('#imageInput2', '.uploadPhotos2');

  });

})(document);
